import { getSelectorAttribute, createCustomerPageSelectors } from '@vy/app-selectors';
import { values } from '@vy/utils';
import React from 'react';
import { INVOICE_DUE_DATE_VALUES } from '../../../pages/customers/CreateCustomerPage/create-customer-page-consts/invoice-due-date-consts';
import type { StyledTextField } from '../StyledTextField';
import { BaseSelect } from './BaseSelect';

type InvoiceDueDateSelectProps = Omit<React.ComponentProps<typeof StyledTextField>, 'options'> & {
  textFieldProps?: React.InputHTMLAttributes<HTMLInputElement>;
};

export const InvoiceDueDateSelect = React.forwardRef<HTMLInputElement, InvoiceDueDateSelectProps>(
  (props, ref) => {
    const getDueDateDisplayText = (value: number | string) => {
      return `Net ${value.toString() === INVOICE_DUE_DATE_VALUES.EOM.toString() ? 'EoM' : value}`;
    };

    return (
      <BaseSelect
        {...getSelectorAttribute(createCustomerPageSelectors.configuration.invoiceDueDate)}
        {...props}
        ref={ref}
        withNone={false}
        values={values(INVOICE_DUE_DATE_VALUES)}
        label="Invoice Due Date"
        getLabelOption={getDueDateDisplayText}
      />
    );
  },
);
